export const locales = {
	apply: 'Appliquer le filtre'
};
